import {DocSpeciality} from '@drl/shared/utility/patients-caregiver-utility.enum';
import {PrescriptionMedicines} from './prescription-medicines.model';
import { Medicine } from './medicine-log.model';
import { MedicineReminder } from './medicine-reminder.model';

export class Prescriptions {
  id?: number;
  externalId?: string;
  prescriptionDate: Date;
  startDate?: Date;
  endDate?: Date;
  duration?: number;
  instructions?: string;
  patientId?: number;
  appointmentId?: number;
  doctorName?: string;
  doctorSpeciality?: DocSpeciality;
  medicines?: PrescriptionMedicines[];
  isActive?: boolean;
  type?: string; //display logic
  style?: string; //display logic
  uniqId?: number;
  name?: string;
  patientName?: string;
  mobile?: string;
  prescDateTimeString?: string;
  doctorSpecialty?: string;
  searchBy?: string;
  patientExternalId?: string;
  doctorUserId?: number;
  status?: any;
  patientRiskCategory?: number;
  cycleDays?: number;
  medIntakeDays?: number;
  completionDate?: Date;
  fillStatus?: number;
  fillDate?: Date;
  medReminders?: MedicineReminder[];
  isPrescriptionDone?: boolean;
  prescriptionFiles?: any[];
  stopReason?: string;
  stopReasonLc?: string;
  stoppedAt?: Date;
  stoppedBy?: number;
}
